import React from 'react';

import { BVShimmer } from '../../../models/BVShimmers/BVShimmer';

import './bv-shimmer-details.scss';

interface IBVShimmerDetails extends BVShimmer { }

const BVShimmerDetails: React.FunctionComponent<IBVShimmerDetails> = ({ style }) => (
    <div className="bv-shimmer-details" style={style}>
        <div className="shimmer-wrapper">
            <div className="shimmer-details shimmer-details-large">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-details">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-details shimmer-details-large">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
        </div>
    </div>
);

export default BVShimmerDetails;